/** @file Applies one animation onto a pose with alpha and replace/add blending (single-track convenience). */
import type { Pose } from '../contracts/pose';
import type { Sample } from '../contracts/sample';
import type { SkeletonData, SkinData } from '../skeletonData';
import { applyDiscreteChannels } from './applyDiscreteChannels';
import { blendSample } from './blendSample';
import { sampleAnimation } from './sampleAnimation';

/** W2-07: without a track entry, discrete channels switch at 0.5 (the attachment and draw-order threshold default). */
const DISCRETE_THRESHOLD = 0.5;

/** Samples anim at time and blends it onto pose.local/slots/ik (attachments resolved through `opts.skin`); does not run updatePose. */
export function applyAnimation(pose: Pose, data: SkeletonData, anim: number, time: number, opts: { alpha: number; blend: 'replace' | 'add'; sample: Sample; skin: SkinData }): void {
  // lastTime = time: an empty event window, so opts.sample.eventCount is 0 (events are stepState's job, W2-08).
  sampleAnimation(opts.sample, data, anim, time, time);
  blendSample(pose, data, opts.sample, opts.alpha, opts.blend);
  if (opts.alpha >= DISCRETE_THRESHOLD) applyDiscreteChannels(pose, data, opts.sample, opts.skin);
}
